import React from 'react'
import { Box, Typography, Grid } from '@mui/material'

interface NicheCategory {
  id: string
  slug: string
  displayName: string
  description?: string | null
  iconEmoji?: string | null
  contentCount: number
}

interface NicheGridProps {
  niches: NicheCategory[]
  onSelectNiche: (niche: { id: string; name: string; emoji: string }) => void
}

export default function NicheGrid({ niches, onSelectNiche }: NicheGridProps) {
  return (
    <Grid container spacing={2}>
      {niches.map((niche) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={niche.id}>
          <Box
            onClick={() =>
              onSelectNiche({
                id: niche.id,
                name: niche.displayName,
                emoji: niche.iconEmoji ?? '',
              })
            }
            sx={{
              backgroundColor: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '16px',
              padding: '20px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.06)',
                borderColor: 'rgba(168, 85, 247, 0.4)',
                transform: 'translateY(-2px)',
              },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <Box
                sx={{
                  width: '44px',
                  height: '44px',
                  borderRadius: '12px',
                  background: 'linear-gradient(135deg, rgba(168, 85, 247, 0.2) 0%, rgba(99, 102, 241, 0.2) 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                }}
              >
                {niche.iconEmoji}
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: 'white',
                    fontSize: '15px',
                    lineHeight: 1.3,
                  }}
                >
                  {niche.displayName}
                </Typography>
              </Box>
            </Box>
            <Typography
              sx={{
                color: 'rgba(255,255,255,0.5)',
                fontSize: '13px',
                lineHeight: 1.4,
                marginBottom: '8px',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {niche.description}
            </Typography>
            <Typography
              sx={{
                color: 'rgba(168, 85, 247, 0.8)',
                fontSize: '12px',
                fontWeight: 500,
              }}
            >
              {niche.contentCount.toLocaleString()} posts
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}
